import { grey } from 'assets/colors/colors';

export const archiveAccountingCodeSpanStyle = {
  color: grey.g500,
  fontWeight: '500',
  marginLeft: '2px',
};
